import { forwardRef, InputHTMLAttributes } from 'react';
import InputError from './InputError';

interface LabeledTextAreaProps extends InputHTMLAttributes<HTMLTextAreaElement> {
  label: string;
  error?: string;
}

const LabeledTextArea = forwardRef<HTMLTextAreaElement, LabeledTextAreaProps>(
  ({ label, error, ...props }, ref) => {
    return (
      <fieldset className="form-control w-full">
        <legend className="label">
          <span className="fieldset-legend text-primary font-semibold text-sm">
            {label}
          </span>
        </legend>
        <textarea
          ref={ref}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
          className={`textarea textarea-lg bg-white placeholder:text-[var(--light-gray)] w-full ${error ? 'input-error border-error' : ''}`}
        />
        <InputError error={error} />
      </fieldset>
    );
  }
);

LabeledTextArea.displayName = 'LabeledTextArea';

export default LabeledTextArea;
